"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _icon = _interopRequireDefault(require("../icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SvgPlusCircle = function SvgPlusCircle(props, svgRef) {
  return /*#__PURE__*/React.createElement(_icon["default"], _objectSpread(_objectSpread({}, props), {}, {
    component: function component() {
      return /*#__PURE__*/React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 1000 1000",
        fill: "currentColor",
        focusable: false,
        "aria-hidden": "true",
        ref: svgRef
      }, /*#__PURE__*/React.createElement("g", {
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M472.222 472.222V277.778C472.222 262.437 484.66 250 500 250h.143c15.262.08 27.57 12.516 27.49 27.777l-1.009 194.445h195.598C737.563 472.222 750 484.66 750 500s-12.437 27.778-27.778 27.778H526.336l-1.017 195.743C525.243 738.167 513.35 750 498.702 750c-14.624 0-26.48-11.855-26.48-26.48V527.778H277.778C262.437 527.778 250 515.34 250 500s12.437-27.778 27.778-27.778h194.444z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M500 937.5c241.625 0 437.5-195.875 437.5-437.5S741.625 62.5 500 62.5 62.5 258.375 62.5 500 258.375 937.5 500 937.5zm0 62.5C223.858 1000 0 776.142 0 500S223.858 0 500 0s500 223.858 500 500-223.858 500-500 500z",
        fillRule: "nonzero"
      })));
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
var _default = ForwardRef;
exports["default"] = _default;